module.exports = __webpack_public_path__ + "media/images/application/template/icon-download-generic-340b8d9f10fcc44bb28f13e86346db17.svg";